/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceContentBlockType } from './SurfaceContentBlockType';
import {
    SurfaceContentBlockTypeFromJSON,
    SurfaceContentBlockTypeFromJSONTyped,
    SurfaceContentBlockTypeToJSON,
    SurfaceContentBlockTypeToJSONTyped,
} from './SurfaceContentBlockType';
import type { SurfaceScrollNavConfig } from './SurfaceScrollNavConfig';
import {
    SurfaceScrollNavConfigFromJSON,
    SurfaceScrollNavConfigFromJSONTyped,
    SurfaceScrollNavConfigToJSON,
    SurfaceScrollNavConfigToJSONTyped,
} from './SurfaceScrollNavConfig';
import type { SurfaceBlockLayout } from './SurfaceBlockLayout';
import {
    SurfaceBlockLayoutFromJSON,
    SurfaceBlockLayoutFromJSONTyped,
    SurfaceBlockLayoutToJSON,
    SurfaceBlockLayoutToJSONTyped,
} from './SurfaceBlockLayout';
import type { SurfaceNotificationSignupConfig } from './SurfaceNotificationSignupConfig';
import {
    SurfaceNotificationSignupConfigFromJSON,
    SurfaceNotificationSignupConfigFromJSONTyped,
    SurfaceNotificationSignupConfigToJSON,
    SurfaceNotificationSignupConfigToJSONTyped,
} from './SurfaceNotificationSignupConfig';
import type { SurfaceStreamZoneConfig } from './SurfaceStreamZoneConfig';
import {
    SurfaceStreamZoneConfigFromJSON,
    SurfaceStreamZoneConfigFromJSONTyped,
    SurfaceStreamZoneConfigToJSON,
    SurfaceStreamZoneConfigToJSONTyped,
} from './SurfaceStreamZoneConfig';
import type { SurfaceBlockDesign } from './SurfaceBlockDesign';
import {
    SurfaceBlockDesignFromJSON,
    SurfaceBlockDesignFromJSONTyped,
    SurfaceBlockDesignToJSON,
    SurfaceBlockDesignToJSONTyped,
} from './SurfaceBlockDesign';
import type { SurfaceGamificationConfig } from './SurfaceGamificationConfig';
import {
    SurfaceGamificationConfigFromJSON,
    SurfaceGamificationConfigFromJSONTyped,
    SurfaceGamificationConfigToJSON,
    SurfaceGamificationConfigToJSONTyped,
} from './SurfaceGamificationConfig';
import type { SurfaceVideoConfig } from './SurfaceVideoConfig';
import {
    SurfaceVideoConfigFromJSON,
    SurfaceVideoConfigFromJSONTyped,
    SurfaceVideoConfigToJSON,
    SurfaceVideoConfigToJSONTyped,
} from './SurfaceVideoConfig';
import type { SurfacePollConfig } from './SurfacePollConfig';
import {
    SurfacePollConfigFromJSON,
    SurfacePollConfigFromJSONTyped,
    SurfacePollConfigToJSON,
    SurfacePollConfigToJSONTyped,
} from './SurfacePollConfig';
import type { SurfaceSponsorItem } from './SurfaceSponsorItem';
import {
    SurfaceSponsorItemFromJSON,
    SurfaceSponsorItemFromJSONTyped,
    SurfaceSponsorItemToJSON,
    SurfaceSponsorItemToJSONTyped,
} from './SurfaceSponsorItem';
import type { SurfaceCodeEntryConfig } from './SurfaceCodeEntryConfig';
import {
    SurfaceCodeEntryConfigFromJSON,
    SurfaceCodeEntryConfigFromJSONTyped,
    SurfaceCodeEntryConfigToJSON,
    SurfaceCodeEntryConfigToJSONTyped,
} from './SurfaceCodeEntryConfig';
import type { SurfaceImageGalleryConfig } from './SurfaceImageGalleryConfig';
import {
    SurfaceImageGalleryConfigFromJSON,
    SurfaceImageGalleryConfigFromJSONTyped,
    SurfaceImageGalleryConfigToJSON,
    SurfaceImageGalleryConfigToJSONTyped,
} from './SurfaceImageGalleryConfig';
import type { SurfaceLeaderboardBlockConfig } from './SurfaceLeaderboardBlockConfig';
import {
    SurfaceLeaderboardBlockConfigFromJSON,
    SurfaceLeaderboardBlockConfigFromJSONTyped,
    SurfaceLeaderboardBlockConfigToJSON,
    SurfaceLeaderboardBlockConfigToJSONTyped,
} from './SurfaceLeaderboardBlockConfig';
import type { SurfaceOnboardingConfig } from './SurfaceOnboardingConfig';
import {
    SurfaceOnboardingConfigFromJSON,
    SurfaceOnboardingConfigFromJSONTyped,
    SurfaceOnboardingConfigToJSON,
    SurfaceOnboardingConfigToJSONTyped,
} from './SurfaceOnboardingConfig';
import type { SurfaceContainerConfig } from './SurfaceContainerConfig';
import {
    SurfaceContainerConfigFromJSON,
    SurfaceContainerConfigFromJSONTyped,
    SurfaceContainerConfigToJSON,
    SurfaceContainerConfigToJSONTyped,
} from './SurfaceContainerConfig';
import type { SurfaceStreamingBlockConfig } from './SurfaceStreamingBlockConfig';
import {
    SurfaceStreamingBlockConfigFromJSON,
    SurfaceStreamingBlockConfigFromJSONTyped,
    SurfaceStreamingBlockConfigToJSON,
    SurfaceStreamingBlockConfigToJSONTyped,
} from './SurfaceStreamingBlockConfig';
import type { SurfaceColumnsConfig } from './SurfaceColumnsConfig';
import {
    SurfaceColumnsConfigFromJSON,
    SurfaceColumnsConfigFromJSONTyped,
    SurfaceColumnsConfigToJSON,
    SurfaceColumnsConfigToJSONTyped,
} from './SurfaceColumnsConfig';
import type { SurfaceEarningRulesConfig } from './SurfaceEarningRulesConfig';
import {
    SurfaceEarningRulesConfigFromJSON,
    SurfaceEarningRulesConfigFromJSONTyped,
    SurfaceEarningRulesConfigToJSON,
    SurfaceEarningRulesConfigToJSONTyped,
} from './SurfaceEarningRulesConfig';
import type { SurfaceStepsConfig } from './SurfaceStepsConfig';
import {
    SurfaceStepsConfigFromJSON,
    SurfaceStepsConfigFromJSONTyped,
    SurfaceStepsConfigToJSON,
    SurfaceStepsConfigToJSONTyped,
} from './SurfaceStepsConfig';
import type { SurfaceMyPositionConfig } from './SurfaceMyPositionConfig';
import {
    SurfaceMyPositionConfigFromJSON,
    SurfaceMyPositionConfigFromJSONTyped,
    SurfaceMyPositionConfigToJSON,
    SurfaceMyPositionConfigToJSONTyped,
} from './SurfaceMyPositionConfig';
import type { SurfaceSocialEmbedConfig } from './SurfaceSocialEmbedConfig';
import {
    SurfaceSocialEmbedConfigFromJSON,
    SurfaceSocialEmbedConfigFromJSONTyped,
    SurfaceSocialEmbedConfigToJSON,
    SurfaceSocialEmbedConfigToJSONTyped,
} from './SurfaceSocialEmbedConfig';
import type { SurfaceCtaConfig } from './SurfaceCtaConfig';
import {
    SurfaceCtaConfigFromJSON,
    SurfaceCtaConfigFromJSONTyped,
    SurfaceCtaConfigToJSON,
    SurfaceCtaConfigToJSONTyped,
} from './SurfaceCtaConfig';
import type { SurfaceChallengeZoneConfig } from './SurfaceChallengeZoneConfig';
import {
    SurfaceChallengeZoneConfigFromJSON,
    SurfaceChallengeZoneConfigFromJSONTyped,
    SurfaceChallengeZoneConfigToJSON,
    SurfaceChallengeZoneConfigToJSONTyped,
} from './SurfaceChallengeZoneConfig';
import type { SurfacePromoItem } from './SurfacePromoItem';
import {
    SurfacePromoItemFromJSON,
    SurfacePromoItemFromJSONTyped,
    SurfacePromoItemToJSON,
    SurfacePromoItemToJSONTyped,
} from './SurfacePromoItem';
import type { SurfaceRewardsConfig } from './SurfaceRewardsConfig';
import {
    SurfaceRewardsConfigFromJSON,
    SurfaceRewardsConfigFromJSONTyped,
    SurfaceRewardsConfigToJSON,
    SurfaceRewardsConfigToJSONTyped,
} from './SurfaceRewardsConfig';
import type { SurfacePrizesConfig } from './SurfacePrizesConfig';
import {
    SurfacePrizesConfigFromJSON,
    SurfacePrizesConfigFromJSONTyped,
    SurfacePrizesConfigToJSON,
    SurfacePrizesConfigToJSONTyped,
} from './SurfacePrizesConfig';
import type { SurfaceStoreLocatorConfig } from './SurfaceStoreLocatorConfig';
import {
    SurfaceStoreLocatorConfigFromJSON,
    SurfaceStoreLocatorConfigFromJSONTyped,
    SurfaceStoreLocatorConfigToJSON,
    SurfaceStoreLocatorConfigToJSONTyped,
} from './SurfaceStoreLocatorConfig';
import type { SurfaceFaqConfig } from './SurfaceFaqConfig';
import {
    SurfaceFaqConfigFromJSON,
    SurfaceFaqConfigFromJSONTyped,
    SurfaceFaqConfigToJSON,
    SurfaceFaqConfigToJSONTyped,
} from './SurfaceFaqConfig';
import type { SurfaceProductsConfig } from './SurfaceProductsConfig';
import {
    SurfaceProductsConfigFromJSON,
    SurfaceProductsConfigFromJSONTyped,
    SurfaceProductsConfigToJSON,
    SurfaceProductsConfigToJSONTyped,
} from './SurfaceProductsConfig';
import type { SurfaceStatsConfig } from './SurfaceStatsConfig';
import {
    SurfaceStatsConfigFromJSON,
    SurfaceStatsConfigFromJSONTyped,
    SurfaceStatsConfigToJSON,
    SurfaceStatsConfigToJSONTyped,
} from './SurfaceStatsConfig';

/**
 * Configurable content section for hub pages
 * @export
 * @interface SurfaceContentBlock
 */
export interface SurfaceContentBlock {
    /**
     * 
     * @type {SurfaceContentBlockType}
     * @memberof SurfaceContentBlock
     */
    type?: SurfaceContentBlockType;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceContentBlock
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceContentBlock
     */
    order?: number;
    /**
     * Raw HTML content (for HTML type)
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    htmlContent?: string;
    /**
     * Width percentage 0-100 (for HTML type)
     * @type {number}
     * @memberof SurfaceContentBlock
     */
    widthPercentage?: number;
    /**
     * 
     * @type {Array<SurfacePromoItem>}
     * @memberof SurfaceContentBlock
     */
    promoItems?: Array<SurfacePromoItem>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    promoLayout?: SurfaceContentBlockPromoLayoutEnum;
    /**
     * Text content (for TEXT_IMAGE type)
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    textContent?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    imagePosition?: SurfaceContentBlockImagePositionEnum;
    /**
     * 
     * @type {SurfaceRewardsConfig}
     * @memberof SurfaceContentBlock
     */
    rewardsConfig?: SurfaceRewardsConfig;
    /**
     * 
     * @type {SurfaceProductsConfig}
     * @memberof SurfaceContentBlock
     */
    productsConfig?: SurfaceProductsConfig;
    /**
     * AUTO uses nearest competition start date, FIXED uses countdownTargetDate
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    countdownSource?: SurfaceContentBlockCountdownSourceEnum;
    /**
     * Fixed countdown target (epoch ms), used when countdownSource is FIXED
     * @type {number}
     * @memberof SurfaceContentBlock
     */
    countdownTargetDate?: number;
    /**
     * Label displayed above the countdown timer
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    countdownLabel?: string;
    /**
     * 
     * @type {Array<SurfaceSponsorItem>}
     * @memberof SurfaceContentBlock
     */
    sponsors?: Array<SurfaceSponsorItem>;
    /**
     * Tournament competition ID for LIVE_BRACKET type
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    bracketCompetitionId?: string;
    /**
     * Optional section title override
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    sectionTitle?: string;
    /**
     * Asset ID for images (TEXT_IMAGE type)
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    imageId?: string;
    /**
     * 
     * @type {SurfaceBlockDesign}
     * @memberof SurfaceContentBlock
     */
    blockDesign?: SurfaceBlockDesign;
    /**
     * 
     * @type {SurfaceStepsConfig}
     * @memberof SurfaceContentBlock
     */
    stepsConfig?: SurfaceStepsConfig;
    /**
     * 
     * @type {SurfacePrizesConfig}
     * @memberof SurfaceContentBlock
     */
    prizesConfig?: SurfacePrizesConfig;
    /**
     * 
     * @type {SurfaceFaqConfig}
     * @memberof SurfaceContentBlock
     */
    faqConfig?: SurfaceFaqConfig;
    /**
     * 
     * @type {SurfaceLeaderboardBlockConfig}
     * @memberof SurfaceContentBlock
     */
    leaderboardConfig?: SurfaceLeaderboardBlockConfig;
    /**
     * 
     * @type {SurfaceCtaConfig}
     * @memberof SurfaceContentBlock
     */
    ctaConfig?: SurfaceCtaConfig;
    /**
     * 
     * @type {SurfaceVideoConfig}
     * @memberof SurfaceContentBlock
     */
    videoConfig?: SurfaceVideoConfig;
    /**
     * 
     * @type {SurfaceBlockLayout}
     * @memberof SurfaceContentBlock
     */
    layout?: SurfaceBlockLayout;
    /**
     * BrandActivation ID (for PLAYABLE_AD, BRAND_CHALLENGE, QUEST_SPONSORSHIP, GUILD_SPONSORSHIP types)
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    activationId?: string;
    /**
     * Visual display mode for entity blocks (e.g. objectives_list, progress, card, full_widget)
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    displayMode?: string;
    /**
     * Competition ID (for COMPETITION block type)
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    competitionId?: string;
    /**
     * QuestConfig ID (for QUEST block type)
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    questConfigId?: string;
    /**
     * 
     * @type {SurfaceImageGalleryConfig}
     * @memberof SurfaceContentBlock
     */
    imageGalleryConfig?: SurfaceImageGalleryConfig;
    /**
     * 
     * @type {SurfaceStatsConfig}
     * @memberof SurfaceContentBlock
     */
    statsConfig?: SurfaceStatsConfig;
    /**
     * 
     * @type {SurfaceSocialEmbedConfig}
     * @memberof SurfaceContentBlock
     */
    socialEmbedConfig?: SurfaceSocialEmbedConfig;
    /**
     * 
     * @type {SurfaceStreamingBlockConfig}
     * @memberof SurfaceContentBlock
     */
    streamingConfig?: SurfaceStreamingBlockConfig;
    /**
     * 
     * @type {SurfaceNotificationSignupConfig}
     * @memberof SurfaceContentBlock
     */
    notificationSignupConfig?: SurfaceNotificationSignupConfig;
    /**
     * 
     * @type {SurfacePollConfig}
     * @memberof SurfaceContentBlock
     */
    pollConfig?: SurfacePollConfig;
    /**
     * 
     * @type {SurfaceContainerConfig}
     * @memberof SurfaceContentBlock
     */
    containerConfig?: SurfaceContainerConfig;
    /**
     * 
     * @type {SurfaceColumnsConfig}
     * @memberof SurfaceContentBlock
     */
    columnsConfig?: SurfaceColumnsConfig;
    /**
     * 
     * @type {SurfaceScrollNavConfig}
     * @memberof SurfaceContentBlock
     */
    scrollNavConfig?: SurfaceScrollNavConfig;
    /**
     * 
     * @type {SurfaceStoreLocatorConfig}
     * @memberof SurfaceContentBlock
     */
    storeLocatorConfig?: SurfaceStoreLocatorConfig;
    /**
     * 
     * @type {SurfaceMyPositionConfig}
     * @memberof SurfaceContentBlock
     */
    myPositionConfig?: SurfaceMyPositionConfig;
    /**
     * 
     * @type {SurfaceOnboardingConfig}
     * @memberof SurfaceContentBlock
     */
    onboardingConfig?: SurfaceOnboardingConfig;
    /**
     * 
     * @type {SurfaceEarningRulesConfig}
     * @memberof SurfaceContentBlock
     */
    earningRulesConfig?: SurfaceEarningRulesConfig;
    /**
     * 
     * @type {SurfaceCodeEntryConfig}
     * @memberof SurfaceContentBlock
     */
    codeEntryConfig?: SurfaceCodeEntryConfig;
    /**
     * 
     * @type {SurfaceGamificationConfig}
     * @memberof SurfaceContentBlock
     */
    gamificationConfig?: SurfaceGamificationConfig;
    /**
     * LOOTBOX type — optional LootBoxConfig ID. When set, shows only that config; when absent, shows all active hub-placement boxes.
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    lootBoxConfigId?: string;
    /**
     * 
     * @type {SurfaceStreamZoneConfig}
     * @memberof SurfaceContentBlock
     */
    streamZoneConfig?: SurfaceStreamZoneConfig;
    /**
     * 
     * @type {SurfaceChallengeZoneConfig}
     * @memberof SurfaceContentBlock
     */
    challengeZoneConfig?: SurfaceChallengeZoneConfig;
    /**
     * Page index for multi-page hubs (0 = first page, 1 = second, etc.)
     * @type {number}
     * @memberof SurfaceContentBlock
     */
    pageIndex?: number;
    /**
     * Epoch ms — block is hidden before this time (campaign phase scheduling)
     * @type {number}
     * @memberof SurfaceContentBlock
     */
    showAfter?: number;
    /**
     * Epoch ms — block is hidden after this time (campaign phase scheduling)
     * @type {number}
     * @memberof SurfaceContentBlock
     */
    showUntil?: number;
    /**
     * User-assignable stable slug for scroll nav targeting (e.g. "leaderboard", "prizes"). Persists across PUT updates unlike _id.
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    blockId?: string;
    /**
     * Phase gate — 'pre_launch' shows only before launch, 'live' shows only after launch, 'always' shows in both phases.
     * @type {string}
     * @memberof SurfaceContentBlock
     */
    visiblePhase?: SurfaceContentBlockVisiblePhaseEnum;
}


/**
 * @export
 */
export const SurfaceContentBlockPromoLayoutEnum = {
    _2Up: '2-up',
    _3Up: '3-up'
} as const;
export type SurfaceContentBlockPromoLayoutEnum = typeof SurfaceContentBlockPromoLayoutEnum[keyof typeof SurfaceContentBlockPromoLayoutEnum];

/**
 * @export
 */
export const SurfaceContentBlockImagePositionEnum = {
    left: 'left',
    right: 'right'
} as const;
export type SurfaceContentBlockImagePositionEnum = typeof SurfaceContentBlockImagePositionEnum[keyof typeof SurfaceContentBlockImagePositionEnum];

/**
 * @export
 */
export const SurfaceContentBlockCountdownSourceEnum = {
    AUTO: 'AUTO',
    FIXED: 'FIXED'
} as const;
export type SurfaceContentBlockCountdownSourceEnum = typeof SurfaceContentBlockCountdownSourceEnum[keyof typeof SurfaceContentBlockCountdownSourceEnum];

/**
 * @export
 */
export const SurfaceContentBlockVisiblePhaseEnum = {
    always: 'always',
    pre_launch: 'pre_launch',
    live: 'live'
} as const;
export type SurfaceContentBlockVisiblePhaseEnum = typeof SurfaceContentBlockVisiblePhaseEnum[keyof typeof SurfaceContentBlockVisiblePhaseEnum];


/**
 * Check if a given object implements the SurfaceContentBlock interface.
 */
export function instanceOfSurfaceContentBlock(value: object): value is SurfaceContentBlock {
    return true;
}

export function SurfaceContentBlockFromJSON(json: any): SurfaceContentBlock {
    return SurfaceContentBlockFromJSONTyped(json, false);
}

export function SurfaceContentBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceContentBlock {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : SurfaceContentBlockTypeFromJSON(json['type']),
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'order': json['order'] == null ? undefined : json['order'],
        'htmlContent': json['htmlContent'] == null ? undefined : json['htmlContent'],
        'widthPercentage': json['widthPercentage'] == null ? undefined : json['widthPercentage'],
        'promoItems': json['promoItems'] == null ? undefined : ((json['promoItems'] as Array<any>).map(SurfacePromoItemFromJSON)),
        'promoLayout': json['promoLayout'] == null ? undefined : json['promoLayout'],
        'textContent': json['textContent'] == null ? undefined : json['textContent'],
        'imagePosition': json['imagePosition'] == null ? undefined : json['imagePosition'],
        'rewardsConfig': json['rewardsConfig'] == null ? undefined : SurfaceRewardsConfigFromJSON(json['rewardsConfig']),
        'productsConfig': json['productsConfig'] == null ? undefined : SurfaceProductsConfigFromJSON(json['productsConfig']),
        'countdownSource': json['countdownSource'] == null ? undefined : json['countdownSource'],
        'countdownTargetDate': json['countdownTargetDate'] == null ? undefined : json['countdownTargetDate'],
        'countdownLabel': json['countdownLabel'] == null ? undefined : json['countdownLabel'],
        'sponsors': json['sponsors'] == null ? undefined : ((json['sponsors'] as Array<any>).map(SurfaceSponsorItemFromJSON)),
        'bracketCompetitionId': json['bracketCompetitionId'] == null ? undefined : json['bracketCompetitionId'],
        'sectionTitle': json['sectionTitle'] == null ? undefined : json['sectionTitle'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'blockDesign': json['blockDesign'] == null ? undefined : SurfaceBlockDesignFromJSON(json['blockDesign']),
        'stepsConfig': json['stepsConfig'] == null ? undefined : SurfaceStepsConfigFromJSON(json['stepsConfig']),
        'prizesConfig': json['prizesConfig'] == null ? undefined : SurfacePrizesConfigFromJSON(json['prizesConfig']),
        'faqConfig': json['faqConfig'] == null ? undefined : SurfaceFaqConfigFromJSON(json['faqConfig']),
        'leaderboardConfig': json['leaderboardConfig'] == null ? undefined : SurfaceLeaderboardBlockConfigFromJSON(json['leaderboardConfig']),
        'ctaConfig': json['ctaConfig'] == null ? undefined : SurfaceCtaConfigFromJSON(json['ctaConfig']),
        'videoConfig': json['videoConfig'] == null ? undefined : SurfaceVideoConfigFromJSON(json['videoConfig']),
        'layout': json['layout'] == null ? undefined : SurfaceBlockLayoutFromJSON(json['layout']),
        'activationId': json['activationId'] == null ? undefined : json['activationId'],
        'displayMode': json['displayMode'] == null ? undefined : json['displayMode'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'questConfigId': json['questConfigId'] == null ? undefined : json['questConfigId'],
        'imageGalleryConfig': json['imageGalleryConfig'] == null ? undefined : SurfaceImageGalleryConfigFromJSON(json['imageGalleryConfig']),
        'statsConfig': json['statsConfig'] == null ? undefined : SurfaceStatsConfigFromJSON(json['statsConfig']),
        'socialEmbedConfig': json['socialEmbedConfig'] == null ? undefined : SurfaceSocialEmbedConfigFromJSON(json['socialEmbedConfig']),
        'streamingConfig': json['streamingConfig'] == null ? undefined : SurfaceStreamingBlockConfigFromJSON(json['streamingConfig']),
        'notificationSignupConfig': json['notificationSignupConfig'] == null ? undefined : SurfaceNotificationSignupConfigFromJSON(json['notificationSignupConfig']),
        'pollConfig': json['pollConfig'] == null ? undefined : SurfacePollConfigFromJSON(json['pollConfig']),
        'containerConfig': json['containerConfig'] == null ? undefined : SurfaceContainerConfigFromJSON(json['containerConfig']),
        'columnsConfig': json['columnsConfig'] == null ? undefined : SurfaceColumnsConfigFromJSON(json['columnsConfig']),
        'scrollNavConfig': json['scrollNavConfig'] == null ? undefined : SurfaceScrollNavConfigFromJSON(json['scrollNavConfig']),
        'storeLocatorConfig': json['storeLocatorConfig'] == null ? undefined : SurfaceStoreLocatorConfigFromJSON(json['storeLocatorConfig']),
        'myPositionConfig': json['myPositionConfig'] == null ? undefined : SurfaceMyPositionConfigFromJSON(json['myPositionConfig']),
        'onboardingConfig': json['onboardingConfig'] == null ? undefined : SurfaceOnboardingConfigFromJSON(json['onboardingConfig']),
        'earningRulesConfig': json['earningRulesConfig'] == null ? undefined : SurfaceEarningRulesConfigFromJSON(json['earningRulesConfig']),
        'codeEntryConfig': json['codeEntryConfig'] == null ? undefined : SurfaceCodeEntryConfigFromJSON(json['codeEntryConfig']),
        'gamificationConfig': json['gamificationConfig'] == null ? undefined : SurfaceGamificationConfigFromJSON(json['gamificationConfig']),
        'lootBoxConfigId': json['lootBoxConfigId'] == null ? undefined : json['lootBoxConfigId'],
        'streamZoneConfig': json['streamZoneConfig'] == null ? undefined : SurfaceStreamZoneConfigFromJSON(json['streamZoneConfig']),
        'challengeZoneConfig': json['challengeZoneConfig'] == null ? undefined : SurfaceChallengeZoneConfigFromJSON(json['challengeZoneConfig']),
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'showAfter': json['showAfter'] == null ? undefined : json['showAfter'],
        'showUntil': json['showUntil'] == null ? undefined : json['showUntil'],
        'blockId': json['blockId'] == null ? undefined : json['blockId'],
        'visiblePhase': json['visiblePhase'] == null ? undefined : json['visiblePhase'],
    };
}

export function SurfaceContentBlockToJSON(json: any): SurfaceContentBlock {
    return SurfaceContentBlockToJSONTyped(json, false);
}

export function SurfaceContentBlockToJSONTyped(value?: SurfaceContentBlock | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': SurfaceContentBlockTypeToJSON(value['type']),
        'enabled': value['enabled'],
        'order': value['order'],
        'htmlContent': value['htmlContent'],
        'widthPercentage': value['widthPercentage'],
        'promoItems': value['promoItems'] == null ? undefined : ((value['promoItems'] as Array<any>).map(SurfacePromoItemToJSON)),
        'promoLayout': value['promoLayout'],
        'textContent': value['textContent'],
        'imagePosition': value['imagePosition'],
        'rewardsConfig': SurfaceRewardsConfigToJSON(value['rewardsConfig']),
        'productsConfig': SurfaceProductsConfigToJSON(value['productsConfig']),
        'countdownSource': value['countdownSource'],
        'countdownTargetDate': value['countdownTargetDate'],
        'countdownLabel': value['countdownLabel'],
        'sponsors': value['sponsors'] == null ? undefined : ((value['sponsors'] as Array<any>).map(SurfaceSponsorItemToJSON)),
        'bracketCompetitionId': value['bracketCompetitionId'],
        'sectionTitle': value['sectionTitle'],
        'imageId': value['imageId'],
        'blockDesign': SurfaceBlockDesignToJSON(value['blockDesign']),
        'stepsConfig': SurfaceStepsConfigToJSON(value['stepsConfig']),
        'prizesConfig': SurfacePrizesConfigToJSON(value['prizesConfig']),
        'faqConfig': SurfaceFaqConfigToJSON(value['faqConfig']),
        'leaderboardConfig': SurfaceLeaderboardBlockConfigToJSON(value['leaderboardConfig']),
        'ctaConfig': SurfaceCtaConfigToJSON(value['ctaConfig']),
        'videoConfig': SurfaceVideoConfigToJSON(value['videoConfig']),
        'layout': SurfaceBlockLayoutToJSON(value['layout']),
        'activationId': value['activationId'],
        'displayMode': value['displayMode'],
        'competitionId': value['competitionId'],
        'questConfigId': value['questConfigId'],
        'imageGalleryConfig': SurfaceImageGalleryConfigToJSON(value['imageGalleryConfig']),
        'statsConfig': SurfaceStatsConfigToJSON(value['statsConfig']),
        'socialEmbedConfig': SurfaceSocialEmbedConfigToJSON(value['socialEmbedConfig']),
        'streamingConfig': SurfaceStreamingBlockConfigToJSON(value['streamingConfig']),
        'notificationSignupConfig': SurfaceNotificationSignupConfigToJSON(value['notificationSignupConfig']),
        'pollConfig': SurfacePollConfigToJSON(value['pollConfig']),
        'containerConfig': SurfaceContainerConfigToJSON(value['containerConfig']),
        'columnsConfig': SurfaceColumnsConfigToJSON(value['columnsConfig']),
        'scrollNavConfig': SurfaceScrollNavConfigToJSON(value['scrollNavConfig']),
        'storeLocatorConfig': SurfaceStoreLocatorConfigToJSON(value['storeLocatorConfig']),
        'myPositionConfig': SurfaceMyPositionConfigToJSON(value['myPositionConfig']),
        'onboardingConfig': SurfaceOnboardingConfigToJSON(value['onboardingConfig']),
        'earningRulesConfig': SurfaceEarningRulesConfigToJSON(value['earningRulesConfig']),
        'codeEntryConfig': SurfaceCodeEntryConfigToJSON(value['codeEntryConfig']),
        'gamificationConfig': SurfaceGamificationConfigToJSON(value['gamificationConfig']),
        'lootBoxConfigId': value['lootBoxConfigId'],
        'streamZoneConfig': SurfaceStreamZoneConfigToJSON(value['streamZoneConfig']),
        'challengeZoneConfig': SurfaceChallengeZoneConfigToJSON(value['challengeZoneConfig']),
        'pageIndex': value['pageIndex'],
        'showAfter': value['showAfter'],
        'showUntil': value['showUntil'],
        'blockId': value['blockId'],
        'visiblePhase': value['visiblePhase'],
    };
}

